import { call, put, select, takeLatest } from "redux-saga/effects";
import { fetchDocuments } from "../../../services/accIqService";
import {
  FETCH_DOCUMENTS_REQUEST,
  fetchDocumentFailure,
  fetchDocumentSuccess,
} from "../actions/documentActions";
import { fetchDocumentsV3 } from "../../../services/accIqService";

// Worker Saga
function* fetchDocumentsSaga() {
  try {
    const payload = yield select((state) => state?.documentReducer?.payload);
    const data = yield call(fetchDocumentsV3, payload);
    yield put(fetchDocumentSuccess(data));
  } catch (error) {
    yield put(fetchDocumentFailure(error.message));
  }
}

// Watcher Saga
export function* watchFetchDocuments() {
  yield takeLatest(FETCH_DOCUMENTS_REQUEST, fetchDocumentsSaga);
}
